import React from "react";
import { Bubble } from "react-chartjs-2";
import { Box, Paper } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
ChartJS.register({
  id: "customSpacingLegend",
  beforeInit(chart) {
    // Get reference to the original fit function
    const originalFit = chart.legend.fit;

    // Override the fit function
    chart.legend.fit = function fit() {
      // Call original function and bind scope in order to use `this` correctly inside it
      originalFit.bind(chart.legend)();
      // Change the height as suggested in another answers
      this.height += 15;
    };
  },
});
export default function PlayerProfileChartAnthro(props) {
  const { playervalue, groupvalue, chartName, name, rank, width } = props;
  var popData = {
    datasets: [
      {
        label: [name],
        data: [{ x: playervalue, y: 0, r: 8 }],
        backgroundColor: "Red",
      },
      {
        label: ["Group Average"],
        data: [{ x: groupvalue, y: 0, r: 8 }],
        backgroundColor: "Blue",
      },
    ],
  };
  const formatter = new Intl.NumberFormat("fr");
  return (
    <div style={{ marginLeft: "15%", marginRight: "15%" }}>
      <Box mt={2} mb={2} maxWidth={"400px"}>
        <Paper elevation={2} sx={{ backgroundColor: "#F5F5F5" }}>
          <div style={{ textAlign: "center" }}>
            <h3>{chartName}</h3>
          </div>

          <Bubble
            data={popData}
            options={{
              plugins: {
                tooltip: {
                  callbacks: {
                    label: function (data) {
                      var label = data.label + ":" + data.parsed.x;
                      return label;
                    },
                  },
                },
              },
              scales: {
                xAxes: {
                  beginAtZero: true,
                  grid: {
                    color: "black",
                  },
                  ticks: {
                    color: "black",
                    stepSize: 5,
                  },
                  scaleLabel: {
                    lableString: "Chart Name",
                    display: true,
                  },
                },
                yAxes: {
                  beginAtZero: true,

                  grid: {
                    color: "black",
                  },
                  ticks: {
                    color: "black",

                    stepSize: 0.1,
                    callback: function (value, index, values) {
                      return formatter.format(value);
                    },
                  },
                },
              },
            }}
          />
          <div style={{ textAlign: "center" }}>
            <h3>Rank : {rank}</h3>
          </div>
        </Paper>
      </Box>
    </div>
  );
}
